module.exports = __webpack_public_path__ + "img/landing-page-1.5091484c.webp";